// Path: src\Components\Rewards\RewardStore\RedeemPopup.jsx
import { React, useEffect, useState } from "react";
import myntra from "../../../assets/images/myntra.png";
import TextFieldWithButton from "../../CommonFields/Textfieldwithbutton";
import Coin from "../../../images/coin.png";
import CurrencyIcon from "../../../images/Diamond.png"
import { url } from "../../../config/url";
import { userByToken } from "../../../api/auth.api";
import { checkEmail, validateEmailOtp, applyReward } from "../../../api/account.api";
import { buyAvatar } from "../../../api/coinStore.api";
import { toastError, toastSuccess } from "../../../Utilities/toast";
import Countdown from 'react-countdown';
import { kFormatter } from '../../../Utilities/kFormatter';
import ListLoader from '../../Common/ListLoader';
const ReedemPopup = ({ isOpen, title, onClose, reedemItem, handleReedeemed, isReward, children }) => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOTPError] = useState("");
  const [userDetails, setUserDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = async () => {
    setOtp("");
    setEmailError("");
    let validateEmailRes = validateEmail(email)
    if (!validateEmailRes) {
      setEmailError("please enter valid email id");
      return;
    }
    else {
      try {
        const res = await checkEmail({
          email: email
        });
        if (res?.success) {
          setIsOtp(true)
        }
        else {
          setIsOtp(false)
          toastError(res?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        setIsOtp(false)
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validateOtp = (otp) => {
    const value = otp;
    // Allow only numbers and restrict length to 10 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      return true
    }
    else {
      return false
    }
  };

  const handleValidateButtonClick = async () => {
    setOTPError("");
    if (otp === "") {
      setOTPError("Please enter otp");
    } else if (otp.length < 6) {
      setOTPError("Please enter a 6 digit otp");
    } else {
      try {
        const res = await validateEmailOtp({
          otp: otp
        });
        if (res?.success) {
          setOtp("");
          setIsOtp(false)
          fetchUserDetails();
          if (isReward) {
            redeemReward();
          }
          else {
            buyAvatarList();
          }
        }
        else {
          // setOtp("");
          // setIsOtp(false)
          toastError(res?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        // setOtp("");
        // setIsOtp(false)
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  }

  useEffect(() => {
    fetchUserDetails();
  }, [])

  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const res = await userByToken();
      setIsLoading(false);
      if (res?.success && res?.data) {
        setIsLoading(false);
        setUserDetails(res?.data)
        setEmail(res?.data?.email)
      }
      else {
        setIsLoading(false);
        setUserDetails("")
      }
    } catch (error) {
      setIsLoading(false);
      setUserDetails("")
    }
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      setOtp("");
      setIsOtp(false)
      return <></>;
    } else {
      // Render a countdown
      return <>Request for a new one in {minutes}:{seconds} seconds</>;
    }
  };

  const getTotalBalance = (_id) => {
    let index = userDetails?.wallet?.findIndex((obj) => obj.currency == _id);
  
    if (index > -1) {
      return parseInt(userDetails?.wallet[index].winningAmount) || 0; // Converts to integer
    }
    return 0;
  };
  
  // const getTotalBalance = (_id) => {
  //   let index = userDetails?.wallet?.findIndex((obj) => obj.currency === _id);
  
  //   if (index > -1) {
  //     return userDetails?.wallet[index].winningAmount ? userDetails.wallet[index].winningAmount.toFixed(2) : 0; // Display as decimal
  //   }
  //   return 0;
  // };
  
  

  const redeemReward = async () => {
    try {
      const res = await applyReward({
        product: reedemItem?._id
      });
      if (res?.success) {
        toastSuccess(res?.data?.[0]?.msg);
        handleReedeemed();
        // window.location.reload()
        onClose();
      }
      else {
        toastError(res?.data?.errors?.[0]?.msg);
        onClose();
      }
    } catch (error) {
      toastError(error?.response?.data?.errors?.[0]?.msg);
      onClose();
    }
  };

  const buyAvatarList = async () => {
    try {
      const res = await buyAvatar(reedemItem?._id);
      if (res?.success) {
        toastSuccess(res?.data?.[0]?.msg);
        handleReedeemed();
        window.location.reload()
        onClose();
      }
      else {
        toastError(res?.data?.errors?.[0]?.msg);
        onClose();
      }
    } catch (error) {
      toastError(error?.response?.data?.errors?.[0]?.msg);
      onClose();
    }
  };

  return (
    !isLoading ?
      <div className="popupinner-wrapper">
        <div className="popup-overlay">
          <div className="popup-container">
            <button className="close-btn" onClick={onClose}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    fill="#82838E"
                    fill-opacity="0.5"
                  />
                </g>
                <rect
                  x="12.0531"
                  y="10.9065"
                  width="13.3333"
                  height="1.96078"
                  rx="0.980392"
                  transform="rotate(45 12.0531 10.9065)"
                  fill="#F4F4F4"
                />
                <rect
                  x="10.6666"
                  y="20.3345"
                  width="13.3333"
                  height="1.96078"
                  rx="0.980392"
                  transform="rotate(-45 10.6666 20.3345)"
                  fill="#F4F4F4"
                />
                <defs>
                  <filter
                    id="filter0_b_2731_8186"
                    x="-24"
                    y="-24"
                    width="80"
                    height="80"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_2731_8186"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_2731_8186"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
            <div className="popup-title-img-wrap mt-2 mb-3">
              <div style={{ marginBottom: "10px"}}>
                <img className="reward-store-popup-img" style={{height:'200px', width:"200px"}} src={url?.IMAGE_URL + reedemItem?.img?.default}></img>
              </div>

              <h2 className="popup-header w-100">{title}</h2>

              {isReward &&
                <h2 className="popup-header w-100 ">
                   {" "}
                   
                    {reedemItem?.voucherInfo?.currency?.code === "INR" ?
                      <>
                        {reedemItem?.voucherInfo?.currency?.symbol} {" "}
                        {reedemItem?.voucherInfo?.amount}
                      </>
                      :<>
                        {reedemItem?.voucherInfo?.amount}{" "}   
                        <img className='rewardstore-img-icon-size' src={url?.IMAGE_URL + reedemItem?.voucherInfo?.currency?.img?.default} alt={reedemItem?.name} />
                      </>
                      
                    }
                </h2>
              }
            </div>
            <div className="space-between">
              {((!userDetails?.email || !userDetails?.isEmailVerified) && isReward) &&
                <div className="popup-body">
                  <TextFieldWithButton
                    label="email ID"
                    placeholder="enter email id here"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    buttonText="Send OTP"
                    onButtonClick={handleButtonClick}
                    showButton={isOtp ? false : true}
                    readOnly={userDetails?.isEmailVerified}
                  />
                  {emailError && (
                    <div
                      className="error-message"
                      style={{ fontSize: "12px", position: "static" }}
                    >
                      {emailError}
                    </div>
                  )}{" "}
                </div>
              }
              {(isOtp && isReward) &&
                <>
                  <div className="popup-body">
                    <TextFieldWithButton
                      label="enter otp"
                      placeholder="enter otp"
                      value={otp}
                      onChange={(e) => {
                        setOTPError("");
                        const digitOnlyRegex = /^\d*$/;
                        if (!digitOnlyRegex.test(e.target.value)) {
                          setOTPError("please enter a valid 6-digit otp")
                          return
                        }
                        setOtp(e.target.value)
                      }}
                      showButton={false}
                      minLength={6}
                      maxLength={6}
                    />
                    {otpError && (
                      <div
                        className="error-message"
                        style={{ fontSize: "12px", position: "static" }}
                      >
                        {otpError}
                      </div>
                    )}{" "}
                  </div>
                  <div className="d-flex justify-content-center"><Countdown date={new Date().setSeconds(new Date().getSeconds() + 90)} renderer={renderer} /></div>
                </>
              }

              {/* confirmation box */}
              {isReward ?
                <div className="tournament-joining-popup-confirmationbox">
                  <div className="tournament-joining-popup-confirmation-title">
                    confirmation
                  </div>

                  <div className="tournament-joining-popup-confirmation-currency-balance">
                    {reedemItem?.redeemInfo?.currency?.code} balance =
                    <span className="tournament-joining-popup-currencyamount ms-1">
                    {getTotalBalance(reedemItem?.redeemInfo?.currency?._id)}
  <img className="tournament-joining-popup-img mb-1" src={url?.IMAGE_URL + reedemItem?.redeemInfo?.currency?.img?.default} />
 
</span>
{/* <span className="tournament-joining-popup-currencyamount">
                      <img className="tournament-joining-popup-img" src={url?.IMAGE_URL + reedemItem?.redeemInfo?.currency?.img?.default} />{kFormatter(getTotalBalance(reedemItem?.redeemInfo?.currency?._id))}</span> */}
                  </div>
                </div>
                :
                <div className="tournament-joining-popup-confirmationbox">
                  <div className="tournament-joining-popup-confirmation-title">
                    confirmation
                  </div>

                  <div className="tournament-joining-popup-confirmation-currency-balance">
                    {reedemItem?.currency?.code} balance =
                    <span className="tournament-joining-popup-currencyamount">
  <img className="tournament-joining-popup-img" src={url?.IMAGE_URL + reedemItem?.currency?.img?.default} />
  {getTotalBalance(reedemItem?.currency?._id)}
</span>
                    {/* <span className="tournament-joining-popup-currencyamount">
                      <img className="tournament-joining-popup-img" src={url?.IMAGE_URL + reedemItem?.currency?.img?.default} />{kFormatter(getTotalBalance(reedemItem?.currency?._id))}</span> */}
                  </div>
                </div>
              }

              {/* button */}
              {isReward ?
                (!userDetails?.email || !userDetails?.isEmailVerified) ?
                  <button className='submit-button verify-text' onClick={() => {
                    handleValidateButtonClick()
                  }}>
                    verify & redeem for {reedemItem?.redeemInfo?.amount} <span><img className="verifyandredeem" src={url?.IMAGE_URL + reedemItem?.redeemInfo?.currency?.img?.default}></img></span>
                  </button>
                  :
                  <button className='submit-button verify-text' onClick={() => {
                    redeemReward()
                  }}>
                    redeem for {reedemItem?.redeemInfo?.amount} <span><img className="verifyandredeem" src={url?.IMAGE_URL + reedemItem?.redeemInfo?.currency?.img?.default}></img></span>
                  </button>
                :
                  <button className='submit-button verify-text' onClick={() => {
                    buyAvatarList()
                  }}>
                    redeem for {reedemItem?.coinAmount} <span><img className="verifyandredeem" src={url?.IMAGE_URL + reedemItem?.currency?.img?.default}></img></span>
                  </button>
                }
            </div>
          </div>
        </div>
      </div>
      :
      <>{isLoading && <div className='w-100 d-flex justify-content-center'> <ListLoader/> </div> } </> 
  );
};

export default ReedemPopup;
